import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CError } from "app/common/CError";
import { LoadingButton } from "@mui/lab";
import Title from "app/components/Title";
import { usePartyLimitQuery, usePartyPaymentLimitMutation, } from "generated/generated-models";
import Datepicker from "app/components/DatePicker";
import { useNavigate } from "react-router";
import { Form, Formik } from "formik";
import Input from "app/components/Input";
import { nameof } from "core/util/nameof";
import { useState } from "react";
import { Validate } from "./EditPartyLimitsValidate";
import RequestMultiFactorTokenFormik from "app/components/RequestMultiFactorTokenFormik";
import TimePicker from "app/components/TimePicker";
import { Loading } from "app/lib/components/Loading";
import { Alert, Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, } from "@mui/material";
import { clientConfigFn } from "clientConfig";
import { toDateTime } from "core/util/dateExtensions";
const EditPartyLimitsPage = () => {
    const { data, loading, error } = usePartyLimitQuery({
        fetchPolicy: "network-only",
    });
    const partyLimits = data?.partyLimits;
    const [editLimit, { error: editLimitError, data: editLimitData }] = usePartyPaymentLimitMutation();
    const navigate = useNavigate();
    const date = new Date();
    const [checked, setChecked] = useState(false);
    const [time, setTime] = useState("00:00");
    const [editLimits, setEditLimits] = useState("WithoutMFA");
    const handleRequiresMFA = () => {
        setEditLimits("WithMFA");
    };
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error != null || partyLimits == null) {
        return _jsx(CError, { error: "Could not load party limits" });
    }
    const handleEditLimitsSubmit = async (values) => {
        let effective = undefined;
        if (checked) {
            effective = values.EffectiveTo;
            const splitTime = time.split(":");
            const times = splitTime.map((i) => parseInt(i, 10));
            effective?.setHours(times[0], times[1]);
        }
        const result = await editLimit({
            variables: {
                input: {
                    PayAnyoneLimit: values.PayAnyoneLimit,
                    RedrawLimit: values.RedrawLimit,
                    BpayLimit: values.BpayLimit,
                    EffectiveTo: toDateTime(effective),
                    TwoFactorToken: values.TwoFactorToken,
                },
            },
        });
        if (result.data?.setPartyPaymentLimit?.Code === "499") {
            handleRequiresMFA();
        }
        if (result.data?.setPartyPaymentLimit?.Success) {
            window.location.href = "/Security/Limits";
        }
    };
    const handleCheckChange = () => {
        setChecked(!checked);
    };
    const timeChange = (e) => {
        setTime(e.currentTarget.value);
    };
    const initialValues = {
        PayAnyoneLimit: partyLimits?.DefaultPayAnyoneLimit?.Amount || 0,
        RedrawLimit: partyLimits?.DefaultRedrawLimit?.Amount || 0,
        BpayLimit: partyLimits?.DefaultBPayLimit?.Amount || 0,
        EffectiveTo: undefined,
    };
    return (_jsx(Formik, { initialValues: initialValues, onSubmit: (values) => handleEditLimitsSubmit(values), validationSchema: () => Validate(editLimits === "WithMFA", checked), children: ({ isSubmitting }) => (_jsxs("div", { className: "sub-wrap form-wrap", children: [_jsx(Title, { title: "Edit Daily Transfer Limits" }), _jsxs(Form, { children: [_jsx(Input, { name: nameof("PayAnyoneLimit"), type: "currency", label: "Pay Anyone Limit:", placeHolder: initialValues.PayAnyoneLimit.toString() }), _jsx(Input, { name: nameof("RedrawLimit"), type: "currency", label: "Redraw Limit:", placeHolder: initialValues.RedrawLimit.toString() }), clientConfigFn().showManageBPAYBillers && (_jsx(Input, { name: nameof("BpayLimit"), type: "currency", label: "BPay Limit:", placeHolder: initialValues.BpayLimit.toString() })), _jsx(FormGroup, { children: _jsx(FormControlLabel, { sx: { mb: 3 }, control: _jsx(Checkbox, { onChange: handleCheckChange }), label: "Create Temporary Limits" }) }), checked && (_jsx(Box, { className: "temp-details", sx: { mb: 12 }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 6, children: _jsx(Datepicker, { name: nameof("EffectiveTo"), label: "Effective Until:", minDate: date }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(TimePicker, { time: time, onChange: (e) => timeChange(e) }) })] }) })), _jsx(RequestMultiFactorTokenFormik, { name: "TwoFactorToken", showRequestNewToken: true, requestMfaOnDisplay: true, visible: editLimits === "WithMFA" }), (editLimitError ||
                            editLimitData?.setPartyPaymentLimit?.Success ===
                                false) && (_jsx(Alert, { severity: "error", children: editLimitData?.setPartyPaymentLimit?.Message })), _jsxs("div", { className: "form-group button-row", children: [_jsx(Button, { id: "cancel", variant: "contained", className: "btn-cancel", onClick: () => navigate(-1), children: "Cancel" }), _jsx(LoadingButton, { variant: "contained", type: "submit", loading: isSubmitting, loadingPosition: "end", children: "Save" })] })] })] })) }));
};
export default EditPartyLimitsPage;
